
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'DirectionsInformationCardsWithEquipmentBlock',

  computed: {
    classNameItems: function () {
      let _classes = [];
      if ((this.values?.items || []).length <= 4 || this.cfgs?.count_line === 4) {
        _classes.push('--row');
      }
      return _classes.join(" ");
    },
    useMobileScroll: function () {
      return this.cfgs?.mobile_scroll === 1;
    },
  },

  methods: {
    leaveRequest: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: this.values?.form_type || 'Заказать звонок',
          hideTabs: true,
          miniReachGoal: this.values.reach_goal,
          fullReachGoal: this.values.reach_goal,
        }
      });
    }
  }
});
